export const ROLE_ADMIN_ID = '1'

function roleName(role) {
  return String(role?.name || '').toLowerCase()
}

export function isCompanyAdmin(user) {
  if (!user) return false
  if (user.super_admin === true || user.super_admin === 1 || user.super_admin === '1') return true
  const roles = Array.isArray(user.roles) ? user.roles : []
  return roles.some((role) => String(role?.id) === ROLE_ADMIN_ID || roleName(role) === 'admin')
}

export function isSoleAdminBlock(status) {
  if (!status) return false
  if (status.blockReason === 'sole_admin') return true
  if (status.state === 'blocked' && status.blockReason === 'sole_admin') return true
  return Boolean(status.blocked && status.blockReason === 'sole_admin')
}

export function extractAccountError(errOrRes) {
  const data = errOrRes?.response?.data ?? errOrRes?.data ?? errOrRes
  if (!data) return { code: null, message: null }
  const nested = data.error
  if (typeof nested === 'string') {
    return { code: nested, message: data.message || data.msg || null, scheduledFor: data.scheduled_for, canRestore: data.can_restore }
  }
  if (nested && typeof nested === 'object') {
    return {
      code: nested.code || null,
      message: nested.message || data.message || data.msg || null,
      scheduledFor: nested.scheduled_for ?? data.scheduled_for,
      canRestore: nested.can_restore ?? data.can_restore,
    }
  }
  return {
    code: data.code || null,
    message: data.message || data.msg || null,
    scheduledFor: data.scheduled_for,
    canRestore: data.can_restore,
  }
}

export function parsePendingDeletionFromPayload(payload) {
  if (!payload || typeof payload !== 'object') return null
  const { code, message, scheduledFor, canRestore } = extractAccountError(payload)
  if (code !== 'account_pending_deletion') return null
  return { scheduledFor, canRestore: canRestore !== false, message }
}

/**
 * Login pending deletion: HTTP 403 body `{ error: "account_pending_deletion", scheduled_for, ... }`.
 * With createHttp, 403 is often delivered as a resolved axios response (`{ status: 403, data }`), not a rejected error.
 */
export function parseLoginPendingDeletion(errOrPayload) {
  if (!errOrPayload) return null
  const response = errOrPayload?.response ?? (typeof errOrPayload?.status === 'number' && errOrPayload?.data ? errOrPayload : null)
  const data = response?.data ?? errOrPayload?.response?.data ?? errOrPayload?.data ?? errOrPayload
  const pending = parsePendingDeletionFromPayload(data)
  if (pending) return pending
  const httpStatus = response?.status ?? errOrPayload?.status
  if (httpStatus === 403) return parsePendingDeletionFromPayload(data)
  return null
}
